<template>
  <div class="c-learning-element"
    :class="`c-learning-element--${currentViewName.toLowerCase()}`">
    <components v-if="lessonUnit"
      class="c-carousel__topbar"
      :class="`c-carousel__topbar--${lessonUnit.slug}`"
      :is="currentLETopbar"
      :unitSlug="lessonUnit.slug"
      :unitName="lessonUnit.name"
      :lessonSlug="lessonSlug"
      :lessonName="lesson.name"
      :elementSlug="elementSlug"
      :elementName="elementName || $t(element.__component)"
      :unit="lessonUnit"
    />
    <component v-if="element" :is="currentComponent" :item="element" />
    <LEPagesNav
      v-if="hasPagesNav"
      :next-title="nextTitle"
      :next-image="nextImage"
      :next-link="nextLink"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'

import LEPagesNav from '@/components/LEPagesNav'
import { fetchWithAuth } from '@/api'
import { parseLearningElements, mappedData, componentNameNormalize } from '@/utils'
import { docTitleHandler } from '@/services/title'

const DEFAULT_LE_TOPBAR = 'LETopbarDefault'

const mapLE = {
  Audio: {
    elementName: element => element.name,
    path: 'audio-types'
  },
  Video: {
    elementName: element => element.name,
    path: 'video-types'
  },
  Activity: {
    elementName: element => element.name,
    path: 'activity-types'
  },
  ImageElement: {
    elementName: element => element && element.image_type && element.image_type.name
  }
}

export default {
  components: {
    LEPagesNav
  },

  setup(props, ctx) {
    const lesson = ref({})
    const lessonSlug = computed(() => ctx.root.$options.router.history.current.params.lesson)
    const element = ref({})
    const elementSlug = computed(() => ctx.root.$options.router.history.current.params.id)
    const elementName = ref('')
    const currentViewName = ctx.root.$options.router.history.current.name
    const currentComponent = () => import(`@/components/LearningElements/${currentViewName}`)
    const lessonUnit = ref(null)
    const appLayoutLETopbar = computed(() => ctx.root.$store.getters['appConfig/getAppLayoutLETopbar'] || DEFAULT_LE_TOPBAR)
    const currentLETopbar = () => import(`@/components/${appLayoutLETopbar.value}`)
    const hasPagesNav = ref(false)
    const nextTitle = ref('')
    const nextLink = ref('')
    const nextImage = ref(null)

    onMounted(async () => {
      await ctx.root.$store.dispatch('content/setUnits')
      await ctx.root.$store.dispatch('content/setLesson', lessonSlug.value)

      lesson.value = JSON.parse(JSON.stringify(ctx.root.$store.getters['content/getLessonBySlug'](lessonSlug.value)))
      lessonUnit.value = ctx.root.$store.getters['content/getLessonUnits'](lesson.value.id)[0]

      if (mapLE[currentViewName] !== undefined && mapLE[currentViewName].path) {
        element.value = await (await fetchWithAuth(mapLE[currentViewName].path + '/' + elementSlug.value)).json()
        elementName.value = mapLE[currentViewName].elementName(element.value)
      } else {
        /* look in LE */
        const parsedLE = parseLearningElements(lesson.value.learningElementSection)
        
        element.value = parsedLE.filter(el => mappedData[componentNameNormalize(el.__component)].id(el) === elementSlug.value)[0]
        if(!element.value) {
          /* look in scenario */
          element.value = parseLearningElements(lesson.value.scenario).filter(el => mappedData[componentNameNormalize(el.__component)].id(el) === elementSlug.value)[0]
        } else {
          let currLeIndex = null
          parsedLE.forEach((ple, i) => {
            if (ple.id === element.value.id) {
              currLeIndex = i
            }
          })
          const nextEl = parsedLE[currLeIndex + 1]
          if (nextEl) {
            hasPagesNav.value = true
            nextTitle.value = nextEl.name
            nextImage.value = nextEl.image_type
            nextLink.value = mappedData[componentNameNormalize(nextEl.__component)].link(nextEl.id, lessonSlug.value)
          }
        }

        elementName.value = mapLE[currentViewName] && mapLE[currentViewName].elementName(element.value) || element.value.name || ctx.root.$t(currentViewName)
      }

      element.value.lesson = lessonSlug.value
      element.value.unit = lessonUnit.value.slug

      docTitleHandler(mapLE[currentViewName] && mapLE[currentViewName].elementName(element.value) || element.value.name || ctx.root.$t(currentViewName))
    })

    return {
      currentComponent,
      lesson,
      element,
      lessonSlug,
      lessonUnit,
      elementSlug,
      elementName,
      currentViewName,
      currentLETopbar,
      hasPagesNav,
      nextTitle,
      nextLink,
      nextImage
    }
  }
}
</script>